import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import './Auth.css';

const API = 'https://centrocomunicar.com/api-comunicar/endpoints/auth.php';

const IconLock    = () => (<svg viewBox="0 0 24 24" fill="none" width="17" height="17"><rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M7 11V7a5 5 0 0110 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconEye     = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/></svg>);
const IconEyeOff  = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconArrow   = () => (<svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M4 10h12M11 6l5 4-5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconSpinner = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18" style={{animation:'spin .7s linear infinite'}}><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeOpacity=".25"/><path d="M12 2a10 10 0 0110 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);

export default function ResetPassword() {
  const [params]    = useSearchParams();
  const navigate    = useNavigate();
  const token       = params.get('token') || '';

  const [form,     setForm]     = useState({ password_nueva:'', confirmacion:'' });
  const [verPass,  setVerPass]  = useState(false);
  const [error,    setError]    = useState('');
  const [cargando, setCargando] = useState(false);
  const [ok,       setOk]       = useState(false);

  const setF = (k,v) => setForm(f=>({...f,[k]:v}));

  if (!token) {
    return (
      <div className="auth-page">
        <div className="auth-container">
          <div className="auth-card">
            <div style={{textAlign:'center'}}>
              <p style={{color:'#e53e3e',marginBottom:'1rem'}}>⚠️ Token no válido o expirado.</p>
              <Link to="/recuperar-password" className="auth-submit" style={{display:'inline-flex',textDecoration:'none',justifyContent:'center'}}>
                Solicitar nuevo enlace <IconArrow/>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    if (form.password_nueva.length < 6) { setError('Mínimo 6 caracteres'); return; }
    if (form.password_nueva !== form.confirmacion) { setError('Las contraseñas no coinciden'); return; }
    setCargando(true);
    try {
      const r = await fetch(`${API}?action=reset_pass`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, ...form }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      setOk(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch(err) {
      setError(err.message || 'Error al restablecer la contraseña');
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-bg">
        <div className="auth-blob auth-blob--a"/>
        <div className="auth-blob auth-blob--b"/>
        <div className="auth-grid" aria-hidden="true"/>
      </div>
      <div className="auth-container">
        <Link to="/" className="auth-logo">
          <span className="auth-logo__dot"/>Comunicar
        </Link>
        <div className="auth-card">
          {ok ? (
            <div style={{textAlign:'center',padding:'1rem 0'}}>
              <div style={{width:64,height:64,background:'#d4f4e8',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 1.2rem'}}>
                <svg viewBox="0 0 24 24" fill="none" width="32" height="32"><path d="M8 12l3 3 5-5" stroke="#4db88a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/><circle cx="12" cy="12" r="10" stroke="#4db88a" strokeWidth="2"/></svg>
              </div>
              <h2 style={{fontSize:'1.3rem',marginBottom:'.7rem'}}>¡Contraseña actualizada!</h2>
              <p style={{color:'#5a6a63',fontSize:'.9rem',lineHeight:1.7}}>
                Redirigiendo al login en unos segundos…
              </p>
            </div>
          ) : (
            <>
              <div className="auth-card__head">
                <h1>Nueva contraseña</h1>
                <p>Elige una contraseña segura para tu cuenta.</p>
              </div>
              {error && <div className="auth-error">{error}</div>}
              <form className="auth-form" onSubmit={handleSubmit} noValidate>
                <div className="auth-field">
                  <label>Nueva contraseña</label>
                  <div className="auth-field__wrap">
                    <span className="auth-field__icon"><IconLock/></span>
                    <input
                      type={verPass?'text':'password'} placeholder="Mínimo 6 caracteres"
                      value={form.password_nueva} onChange={e=>setF('password_nueva',e.target.value)} required
                    />
                    <button type="button" className="auth-field__toggle" onClick={()=>setVerPass(v=>!v)}>
                      {verPass?<IconEyeOff/>:<IconEye/>}
                    </button>
                  </div>
                </div>
                <div className="auth-field">
                  <label>Confirmar contraseña</label>
                  <div className="auth-field__wrap">
                    <span className="auth-field__icon"><IconLock/></span>
                    <input
                      type={verPass?'text':'password'} placeholder="Repite la contraseña"
                      value={form.confirmacion} onChange={e=>setF('confirmacion',e.target.value)} required
                    />
                  </div>
                </div>
                <button type="submit" className="auth-submit" disabled={cargando}>
                  {cargando ? <><IconSpinner/> Guardando…</> : <>Guardar contraseña <IconArrow/></>}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}